import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { StackedSidebarService } from '../../../../../services/stacked-sidebar.service';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderSidebarComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();
  public isMobile: any;
  @Input() title: string = '';
  @Input() trigger!: any;
  /** True when hosted inside the chat sidebar, so close() closes the stacked chat dialog instead of the generic right-sidebar. */
  @Input() isChats: boolean = false;
  /** Emitted when the host is a stacked sidebar; the parent component forwards this to its own (close) output. */
  @Output() close = new EventEmitter<void>();

  constructor(private readonly stackedSidebarService: StackedSidebarService) {}

  ngOnInit() {
    this.isMobile = window.innerWidth <= 700;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 700;
  }

  onCloseClick() {
    if (this.isChats) {
      this.stackedSidebarService.closeChats();
    } else {
      this.close.emit();
    }
  }
}
